export default __webpack_public_path__ + "static/media/bannerB.92704559.webp";